module.exports = __webpack_public_path__ + "img/btn_txt_naikan.8f172670.png";